import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import cx from 'clsx';

import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import { Grid } from '@material-ui/core';

import styles from './styles';
import vehiclesEndpoint from 'app/api/services/vehiclesEndpoint';
import { URLS } from 'app/config/urls';
import { useHistory } from 'react-router-dom';
import notification from 'app/config/notification';
import auth from 'app/api/auth';
import licenseEndpoint from 'app/api/services/licenseEndpoint';
import lineEndpoint from '../../../../api/services/lineEndpoint';
const useStyles = makeStyles(styles);

function CardInfo(props) {
  const classes = useStyles();
  const history = useHistory();

  const [totalLicenses, setTotalLicenses] = useState(0);
  const [totalInfractions, setTotalInfractions] = useState(0);
  const [totalVehicles, setTotalVehicles] = useState(0);
  const [totalLines, setTotalLines] = useState(0);

  useEffect(() => {
    const init = async () => {
      if (!!auth.getToken()) {
        const promisses = [];
        promisses.push(
          new Promise((resolve, reject) => {
            try {
              vehiclesEndpoint.getTotalInfractions().then(response => {
                if (response?.status === 200) {
                  setTotalInfractions(response.data);
                }
              });
            } catch (error) {
              notification('Erro de comunicação. Tente novamente.', {
                toastId: 'SERVER_ERROR',
                type: 'error',
              });
            }
          })
        );
        promisses.push(
          new Promise((resolve, reject) => {
            try {
              vehiclesEndpoint.getTotalVehicles().then(response => {
                if (response?.status === 200) {
                  setTotalVehicles(response.data);
                }
              });
            } catch (error) {
              notification('Erro de comunicação. Tente novamente.', {
                toastId: 'SERVER_ERROR',
                type: 'error',
              });
            }
          })
        );
        promisses.push(
          new Promise((resolve, reject) => {
            try {
              const search = { page: 0, size: 1, request: {} };
              licenseEndpoint.getLicenses(search).then(response => {
                if (response?.status === 200 && response.data) {
                  setTotalLicenses(response.data.totalElements || 0);
                }
              });
            } catch (error) {
              notification('Erro de comunicação. Tente novamente.', {
                toastId: 'SERVER_ERROR',
                type: 'error',
              });
            }
          })
        );
        promisses.push(
          new Promise((resolve, reject) => {
            try {
              const search = { page: 0, size: 1, request: {} };
              lineEndpoint.getLines(search).then(response => {
                if (response?.status === 200 && response.data) {
                  setTotalLines(response.data.totalElements || 0);
                }
              });
            } catch (error) {
              notification('Erro de comunicação. Tente novamente.', {
                toastId: 'SERVER_ERROR',
                type: 'error',
              });
            }
          })
        );
        if (promisses.length > 0) await Promise.all(promisses);
      }
    };
    init();
  }, []);

  const onClick = card => {
    switch (card) {
      case 0: //Licenças
        history.push(URLS.LIST_LICENSES);
        break;
      case 1: //Veículos
        history.push(URLS.LIST_VEHICLES);
        break;
      case 2: //Autos
        history.push(URLS.LIST_INFRACTIONS);
        break;
      case 3: //Linhas
        history.push(URLS.LIST_LINES);
        break;
      default:
        break;
    }
  };

  const renderCards = (index, qtd, title, description, onClick) => {
    return (
      <Grid item xs={12} sm={6} md={3} key={index}>
        <Card className={classes.card} onClick={() => onClick(index)}>
          <CardHeader
            className={classes.cardHeader}
            classes={{
              title: classes.titleCardHeader,
              subheader: classes.subTitleCardHeader,
            }}
            avatar={
              <Avatar
                variant="square"
                className={cx(classes.avatar, {
                  first: index === 0,
                  second: index === 1,
                  third: index === 2,
                  fourth: index === 3,
                })}
              >
                {qtd}
              </Avatar>
            }
            title={title}
            subheader={description}
          />
        </Card>
      </Grid>
    );
  };

  return (
    <Grid container spacing={3} className={classes.containerCards}>
      {totalLicenses > 0 && renderCards(0, totalLicenses, 'Licenças', 'disponíveis', onClick)}
      {totalVehicles > 0 && renderCards(1, totalVehicles, 'Veículos', 'cadastrados', onClick)}
      {totalInfractions > 0 && renderCards(2, totalInfractions, 'Autos de infração', '', onClick)}
      {totalLines > 0 && renderCards(3, totalLines, 'Linhas', 'disponíveis', onClick)}
    </Grid>
  );
}

export default CardInfo;
